exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".parredPrice{text-decoration:line-through}@media (max-width:400px){.confirmation table tbody tr{font-size:11px}}@media (max-width:350px){.confirmation table tbody tr{font-size:9px}}@media (min-width:1024px){.confirmation .lastText{margin:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/manage-purchase/confirmation/confirmation.styl
// module id = 947
// module chunks = 0